import { render, staticRenderFns } from "./UpdateRate.vue?vue&type=template&id=635cb5e2&scoped=true&"
import script from "./UpdateRate.vue?vue&type=script&lang=js&"
export * from "./UpdateRate.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRate.vue?vue&type=style&index=0&id=635cb5e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cb5e2",
  null
  
)

export default component.exports